// Single source of truth for the deploy revision identifier.
//
// The value is baked at *build* time via the Vite `define` for
// __DEPLOY_REVISION__ (see vite.config.ts). This guarantees the server
// bundle and the client bundle ship the same string, so the
// <meta name="x-deploy-revision"> tag is stable across SSR + hydration
// and matches the X-Deploy-Revision header the Worker emits.
//
// Override at CI build time:  DEPLOY_REVISION=<commit-sha> npm run build
declare const __DEPLOY_REVISION__: string;

export const DEPLOY_REVISION: string =
  typeof __DEPLOY_REVISION__ !== "undefined" ? __DEPLOY_REVISION__ : "dev";

// Convenience: cache-busting query suffix, e.g. "?v=20260602T154212Z".
export const CACHE_BUST_QS = `v=${encodeURIComponent(DEPLOY_REVISION)}`;

// Append the cache-busting param to any URL without clobbering existing query.
export function withCacheBust(url: string, rev: string = DEPLOY_REVISION): string {
  const sep = url.includes("?") ? "&" : "?";
  return `${url}${sep}v=${encodeURIComponent(rev)}`;
}
